import { UserCreatedInterface } from '../interfaces/user-created.interface';
import { ApiProperty } from '@nestjs/swagger';
import { IsUUID } from 'class-validator';
import { Exclude, Expose } from 'class-transformer';

@Exclude()
export class UserCreatedDto implements UserCreatedInterface {
  @ApiProperty({
    format: 'uuid',
    title: 'Created By User ID',
    description: 'The ID of the user that created this record',
  })
  @IsUUID()
  @Expose()
  createdUserId!: string;
}
